import { useTranslation } from 'react-i18next';
import Button from '@standardsdigital/ui-components/Button';
import ConfirmationDialog from '@standardsdigital/ui-components/ConfirmationDialog';
import IconButton from '@standardsdigital/ui-components/IconButton';
import styles from './ActionsCell.module.css';

interface ActionsCellProps {
  isEditing: boolean;
  isAnotherRowEditing: boolean;
  onSave: () => void;
  onDelete: () => void;
  onEdit: () => void;
  onCancel: () => void;
  deleteConfirmationTitle: string;
  deleteConfirmationDescription: string;
  deleteButtonText: string;
  isBusy?: boolean;
  disableDelete?: boolean;
}

function ActionsCell({
  isEditing,
  isAnotherRowEditing,
  onSave,
  onDelete,
  onEdit,
  onCancel,
  deleteConfirmationTitle,
  deleteConfirmationDescription,
  deleteButtonText,
  isBusy = false,
  disableDelete = false,
}: Readonly<ActionsCellProps>) {
  const { t } = useTranslation();

  if (isEditing) {
    return (
      <div className={styles.actions}>
        <Button size="small" onClick={onCancel} disabled={isBusy}>
          {t('general.cancel')}
        </Button>
        <Button size="small" onClick={onSave} variant="primary" disabled={isBusy}>
          {t('general.save')}
        </Button>
      </div>
    );
  }

  return (
    <div className={styles.actions}>
      <IconButton
        icon="Edit"
        onClick={onEdit}
        size="small"
        disabled={isAnotherRowEditing || isBusy}
      >
        {t('general.edit')}
      </IconButton>
      <ConfirmationDialog
        title={deleteConfirmationTitle}
        description={deleteConfirmationDescription}
        closeButtonText={t('general.close')}
        cancelButtonText={t('general.cancel')}
        confirmButtonText={deleteButtonText}
        onConfirm={onDelete}
        severity="danger"
        modal={false}
      >
        <IconButton
          icon="Trash"
          size="small"
          disabled={disableDelete || isAnotherRowEditing || isBusy}
          layout="icon-only"
        >
          {deleteButtonText}
        </IconButton>
      </ConfirmationDialog>
    </div>
  );
}

export default ActionsCell;
